/**
 * contiene la información para el manejo de productos.
 */
export const defaultProducto = () => {
    return {
        id: null,
        Idproducto: '',
        activo: 1,
        verificado: 1,
        nombre: '',
        sinonimos: '',
        componentesactivos: '',
        componentesactivosIngles: '',
        custom_signal_word: '',
        cas: '',
        estado: '',
        id_fabricante: null,
        uso: '',
        observacion: '',
        disposiciontratamiento: '',
        doc_sga: '',
        doc_etiqueta: '',
        fecha_etiqueta: '',
        tipoproducto: null,
        components: []
    };
};

/**
 * contiene la información de la empresa para documentos.
 */
export const defaultEmpresas = () => {
    return {
        empresas: [],
    };
};

/**
 * contiene la información de la empresa para el inventario.
 */
export const defaultEmpresasInventario = () => {
    return {
        empresas: []
    };
};

/**
 * Valor por defecto del objeto motivo
 */
export const motivo = () => {
    return {
        id_producto: null,
        id_motivo_desbloqueo: null,
        motivo: ''
    };
};

/**
 * Contiene la información de las empresas asignadas y MYS de un producto.
 */
export const defaultCompaniesAssignProduct = () => {
    return {
        companies_assign_product: [],
    };
};

/**
 * Contiene la información inicial del histórico de actualizaciones del inventario.
 * @returns {{data: Array, total: number, current_page: number, per_page: number}}
 * */
export const dataInitialHistoryUpdateProducts = () => {
    return {
        data: [],
        total: 0,
        current_page: 1,
        per_page: 10
    };
};

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedProduct: defaultProducto(),
    empresas_proveedor: [],
    producto_nuevo: false,
    tabs: {
        activo: 0
    },
    modal_desbloqueo: {
        ver: false
    },
    motivos: [],
    motivo: motivo(),
    opcionGuardar: false,
    empresas: [],
    productos: {data: []},
    productos_contratistas: [],
    productos_temporales: [],
    estados: [],
    bases: [],
    areas: [],
    campos: [],
    fabricantes_filtro: [],
    empresas_filtro: [],
    proveedores: [],
    contratistas: [],
    control_existe: [],
    ubicaciones: [],
    ubicacionesContratista: [],
    ubicEmpresa: null,
    arbolUbicaciones: null,
    accion: 'create',
    error: false,
    esAdmin: false,
    esAdminTec: false,
    esEmpresaContratista: false,
    esEmpresa: false,
    esHse: false,
    id_empresa: 0,
    filtro: {
        empresa: null,
        proveedor: null,
        nombre: '',
        sinonimos: '',
        id_fabricante: null,
        confecha: ['', ''],
        ubicaciones: [],
        campoPersonalizado: '',
        selectorMultiple: false,
        valorcampo: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
        contratista: '',
        temporales: false,
        tipo_producto: '',
        pago: false,
        bloqueado: false,
        asignado: false,
        estado: null,
        component: null,
        year_import: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
        is_imported: false,
        in_use:null,
        is_made: false,
        cas: '',
        tipo: '',
        cumplimiento: '',
        comments: '',
        statusEmp: '',
        product_without_company: false,
        product_status: null,
        without_location: false
    },
    check_qr: 1,
    mini: false,
    etiqueta_resolucion: 1,
    formatosEtiqueta: [
        {'value': 'Pdf', 'text': 'Pdf'},
        {'value': 'Word', 'text': 'Word'}
    ],
    etiqueta_vertical: 1,
    pago: false,
    selectedEmpresas: defaultEmpresas(),
    selectedEmpresasInventario: defaultEmpresasInventario(),
    loadingBasesAreas: false,
    rolProductos: '',
    fabricantes: [],
    tipoProductos: [],
    cargando_datos_select: false,
    safety_data_sheets: [],
    companies_assign_product: defaultCompaniesAssignProduct(),
    modalReadPdf : false,
    componentsReadFds: [],
    fileFdsPdf: null,
    typeDocumentIa: '',
    dateDocumentIa: '',
    dateDocumentIaExpiration: "",
    sgaReadFds: [],
    payloadComp: {
        prod_attachment_id: null
    },
    show_info : true,
    in_use : false,
    selectedProducts: [],
    addProductCompany: false,
    productsToAssing:[],
    availableQuantity:0,
    
    // Modulo de cargar de archivo Excel
    upFileExcelShow: {
        show: false,
        type: 'UPDATE'
    },
    responseUpFileExcelProducts: null,
    historyRegistersProductsLoading: false,
    historyRegistersProducts: dataInitialHistoryUpdateProducts()
};
